import {createContext, useContext, useEffect, useState} from "react";
import useApiHook from "../hooks/useApiHook";
import {useAuth} from "./auth-context";

const UserContext = createContext({
    usedSeconds: 0,
    totalSeconds: 0,
    fetchUsage: () => {
    },
    canUploadSeconds: () => {
    },
    hasReachLimit: () => {
    }
});

export const UserProvider = ({children}) => {
    const [usedSeconds, setUsedSeconds] = useState(0);
    const [totalSeconds, setTotalSeconds] = useState(0);
    const {makeRequest, response} = useApiHook();
    const {isAuthenticated} = useAuth();

    useEffect(() => {
        fetchUsage();
    }, [isAuthenticated]);

    useEffect(() => {
        if (response && response.state === 'success') {
            const {secondsLimit, secondsUsed} = response.data;
            setUsedSeconds(secondsUsed);
            setTotalSeconds(secondsLimit);
        }
    }, [response]);

    const fetchUsage = () => {
        if (!isAuthenticated) return;
        makeRequest('/billing/limits');
    };

    const canUploadSeconds = (secondsToUpload = 0) => {
        if (!Number.isFinite(secondsToUpload) || secondsToUpload < 0) return false;
        if (totalSeconds === null) return true;
        if (totalSeconds <= 0) return true;

        return (usedSeconds + secondsToUpload) <= totalSeconds;
    };

    const hasReachLimit = () => {
        if (totalSeconds === null) return false;
        if (totalSeconds <= 0) return false;

        return usedSeconds >= totalSeconds;
    };

    return <UserContext.Provider value={{usedSeconds, totalSeconds, fetchUsage, canUploadSeconds, hasReachLimit}}>
        {children}
    </UserContext.Provider>
}

export const useUser = () => useContext(UserContext);
